module.exports = __webpack_public_path__ + "img/login-logo.f4274a29.png";